<template>
  <!-- 表册管理 -->
  <div class="container" style="display: flex">
    <a-card :bordered="false" class="left-siber">
      <p style="font-weight: 700; margin-left: 16px">分组管理</p>
      <div style="display: flex">
        <a-col :md="24" :sm="24">
          <a-form-item style="margin-left: 2px">
            <a-button type="primary" style="margin-left: 15px" @click="AddModal()" v-action:add>新增</a-button>
            <a-button type="primary" style="margin-left: 15px" @click="EditModal()" v-action:edit>编辑</a-button>
            <a-button type="danger" style="margin-left: 15px" @click="deleteRow()" v-action:del>删除</a-button>
          </a-form-item>
        </a-col>

        <a-modal
          title="新增分组"
          style="top: 20px"
          :width="500"
          :visible="visibles"
          @ok="handleAddGroup"
          @cancel="handleCancel"
        >
          <a-form :form="groupForm">
            <a-form-item label="分组名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                style="width: 100%"
                v-decorator="['groupName', { rules: [{ required: true, message: '请输入组名称' }] }]"
              />
            </a-form-item>
          </a-form>
        </a-modal>

        <a-modal
          title="编辑分组"
          style="top: 20px"
          :width="500"
          :visible="visiblee"
          @ok="handleEditGroup"
          @cancel="handleCancel"
        >
          <a-form :form="groupEditForm">
            <a-form-item label="分组名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                style="width: 100%"
                v-decorator="['groupName', { rules: [{ required: true, message: '请输入组名称' }] }]"
              />
            </a-form-item>
          </a-form>
        </a-modal>
      </div>

      <div class="dropdown-style">
        <a-collapse default-active-key="1" :bordered="false">
          <template #expandIcon="props">
            <a-icon type="caret-right" :rotate="props.isActive ? 90 : 0" style="color: #bfbfbf; font-size: 20px" />
          </template>
          <a-collapse-panel key="1" header="全部分组">
            <a-button
              v-for="(item, index) in GroupList"
              :key="index"
              style="display: block; width: 100%"
              @click="clickButtons(item.id)"
              :style="buttonId === item.id ? { backgroundColor: '#f2f2f2' } : {}"
            >
              {{ item.groupName }}
            </a-button>
          </a-collapse-panel>
        </a-collapse>
      </div>
    </a-card>

    <a-card :bordered="false" class="right-area">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <div class="form-section">
              <div class="select-container">
                <a-form-item label="选择表册：">
                  <a-col :md="6" :sm="12">
                    <a-select
                      show-search
                      placeholder="请选择"
                      style="width: 200px"
                      :filter-option="filterOption"
                      v-model="query.bookName"
                      @change="handleChange"
                    >
                      <a-select-option v-for="book in bookList" :key="book.id" :value="book.bookName">
                        {{ book.bookName }}
                      </a-select-option>
                    </a-select>
                  </a-col>
                </a-form-item>
              </div>

              <div class="button-container">
                <a-col :md="8" :sm="16">
                  <a-form-item>
                    <a-button type="primary" @click="queryList">查询</a-button>
                    <a-button
                      class="reset-btn"
                      @click="
                        buttonId = ''
                        query.bookName = null
                        resetList()
                      "
                      >重置</a-button
                    >
                    <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()" v-action:del
                      >删除</a-button
                    >
                    <a-button type="primary" style="margin-left: 12px" @click="addHandle()" v-action:add>新增</a-button>
                  </a-form-item>
                </a-col>
              </div>
            </div>
          </a-row>
        </a-form>
      </div>

      <a-modal title="新增" style="top: 20px" :width="800" :visible="addvisible" @ok="handleOk" @cancel="handleCancel">
        <a-form class="tenant-form" :form="addOrUpdateForm">
          <a-form-item label="所属分组：" required :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-select
              style="width: 100%"
              v-decorator="['groupId', { rules: [{ required: true, message: '请选择所属分组' }] }]"
            >
              <a-select-option v-for="item in GroupList" :key="item.id" :value="item.id">
                {{ item.groupName }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="表册名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              placeholder="表册名"
              v-decorator="['bookName', { rules: [{ required: true, message: '请输入表册名' }] }]"
              style="width: 100%"
            />
          </a-form-item>
        </a-form>
      </a-modal>

      <a-table
        size="middle"
        rowKey="id"
        bordered
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }"
        :row-class-groupName="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :data-source="list"
        :columns="columns"
        :loading="dataListLoading"
        :pagination="pagination"
        @change="pageChange"
      >
        <span slot="createTime" slot-scope="text">{{ text | moment }}</span>
        <span slot="action" slot-scope="text, record">
          <a @click="addOrUpdateHandle(record)" v-action:edit>编辑</a>
        </span>
      </a-table>
      <a-modal title="编辑" :width="1200" v-model="addOrUpdateVisible" @ok="saveSortOrder" @cancel="handleCancel">
        <div class="EditArea">
          <a-form class="tenant-form" :form="addOrUpdateForm">
            <a-form-item label="所属分组：" required :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select
                style="width: 100%"
                v-decorator="['groupId', { rules: [{ required: true, message: '请选择所属分组' }] }]"
              >
                <a-select-option v-for="item in GroupList" :key="item.id" :value="item.id">
                  {{ item.groupName }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item label="表册名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input
                placeholder="表册名"
                v-decorator="['bookName', { rules: [{ required: true, message: '请输入表册名' }] }]"
                style="width: 100%"
              />
            </a-form-item>
          </a-form>
        </div>

        <div style="display: flex; padding-bottom: 10px; align-items: center; gap: 12px;margin-top: 20px;">
          <a-form-item label="用户编号" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="margin-bottom: 0">
            <a-input v-model="userSearchForm.userCode" placeholder="请输入用户编号" style="width: 200px" allow-clear />
          </a-form-item>
          <a-form-item label="用户名称" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="margin-bottom: 0">
            <a-input v-model="userSearchForm.userName" placeholder="请输入用户名称" style="width: 200px" allow-clear />
          </a-form-item>
          <a-form-item label="水表状态" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }" style="margin-bottom: 0">
            <a-select v-model="userSearchForm.meterStatus" style="width: 200px">
              <a-select-option value=""> 全部 </a-select-option>
              <a-select-option value="1"> 正常 </a-select-option>
              <a-select-option value="2"> 异常 </a-select-option>
              <a-select-option value="3"> 取表 </a-select-option>
              <a-select-option value="4"> 关闸 </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item style="margin-left: 30px;">
            <a-button type="primary" @click="searchUsers">查询</a-button>
            <a-button class="reset-btn" @click="resetUserSearch">重置</a-button>
          </a-form-item>
        </div>

        <div style="display: flex">
          <div class="label"></div>
          <h4 style="font-weight: 700; margin-left: 5px">在册用户</h4>
          <h4 style="color: darkgray; margin-left: auto">可拖动当前列表进行用户排序</h4>
        </div>

        <div>
          <a-table
            ref="userTable"
            class="sortable-table"
            :scroll="{ x: 1500, y: 350 }"
            :columns="userColumns"
            :data-source="userData"
            :loading="userTableLoading"
            rowKey="id"
            :pagination="userPagination"
            @change="handleUserTableChange"
            :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
          >
            <template slot="sortOrder" slot-scope="text, record">
              <div class="sort-order-cell">
                <a-input
                  :value="record.sortOrder"
                  size="small"
                  style="width: 60px"
                  @input="(e) => handleSortOrderInput(e, record)"
                  @blur="(e) => handleSortOrderBlur(e, record)"
                  @pressEnter="(e) => handleSortOrderBlur(e, record)"
                  @keydown="(e) => handleSortOrderKeydown(e, record)"
                  type="text"
                  maxlength="6"
                  pattern="^[1-9][0-9]*$"
                  placeholder="请输入正整数"
                  title="请输入1到总数量之间的正整数"
                />
                <a-icon type="drag" class="drag-handle" />
              </div>
            </template>
          </a-table>
        </div>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'
import Sortable from 'sortablejs'

const columns = [
  {
    title: '序号',
    dataIndex: '',
    key: 'rowIndex',
    width: 70,
    customRender: function (t, r, index) {
      return parseInt(index) + 1
    },
  },
  { title: '所属分组', dataIndex: 'groupName' },
  { title: '表册名称', dataIndex: 'bookName' },
  { title: '在册用户数', dataIndex: 'userCount' },
  { title: '创建时间', dataIndex: 'createTime' },
  { title: '更新时间', dataIndex: 'updateTime' },
  { title: '操作', width: '150px', dataIndex: 'action', scopedSlots: { customRender: 'action' } },
]
// 用户列表表格列定义
const userColumns = [
  { title: '排序', dataIndex: 'sortOrder', width: 100, scopedSlots: { customRender: 'sortOrder' } },
  { title: '用户编码', dataIndex: 'userCode' },
  { title: '用户名称', dataIndex: 'userName' },
  { title: '水表编号', dataIndex: 'meterNumber' },
  { title: '用户地址', dataIndex: 'userAddress', width: 180 },
  {
    title: '用水性质',
    dataIndex: 'waterUsageType',
    customRender: (text) => {
      switch (text) {
        case 1:
          return '居民用水'
        case 2:
          return '非居民用水'
        case 3:
          return '特种用水'
        case 4:
          return '工业用水'
        case 5:
          return '混合用水'
        default:
          return text || '-'
      }
    },
  },
  { title: '手机号码', dataIndex: 'phoneNumber' },
  { title: '口径', dataIndex: 'caliber' },
  { title: '品牌', dataIndex: 'brand' },
  {
    title: '类型',
    dataIndex: 'meterType',
    customRender: (text) => {
      switch (text) {
        case 1:
          return '机械表'
        case 2:
          return '远传表'
        default:
          return text || '-'
      }
    },
  },
  {
    title: '状态',
    dataIndex: 'meterStatus',
    customRender: (text) => {
      switch (text) {
        case 1:
          return '正常'
        case 2:
          return '异常'
        case 3:
          return '已取表'
        case 4:
          return '关闸'
        default:
          return text || '-'
      }
    },
    // fixed: 'right',
  },
]

export default {
  components: {},
  mixins: [mixinViewModule],
  groupName: 'StatisticalForms',
  data() {
    return {
      userData: [], // 用户列表数据
      userTableLoading: false, // 用户表格加载状态
      userColumns, // 用户列表表格列定义
      userSearchForm: {
        userCode: '', // 用户编号搜索
        userName: '', // 用户名称搜索
        meterStatus: '1', // 水表状态
        bookId: null, // 当前表册ID
      },
      originalGroupId: null, // 保存原始分组ID，用于检测分组变更
      // 分页相关数据
      userPagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条/总共 ${total} 条`,
      },
      // 存储所有用户数据用于排序
      allUserData: [],
      // 存储过滤后的用户数据
      filteredUserData: null,
      // 存储全部用户总数(不受搜索影响)
      totalUserCount: 0,
      visibles: false,
      visiblee: false,
      addvisible: false,
      currentGroupId: null,
      groupForm: this.$form.createForm(this, { groupName: 'groupForm' }),
      groupEditForm: this.$form.createForm(this, { groupName: 'groupEditForm' }),
      selectedValue: null,
      activeGroup: null,
      importLoading: false,
      fileList: [],
      queryUrl: '/meter-manager/meterBooks/page',
      addOrUpdateUrl: '/meter-manager/meterBooks',
      // 分组相关API URLs
      groupListUrl: '/meter-manager/meter_book_groups/list',
      groupAddOrUpdateUrl: '/meter-manager/meter_book_groups/insert',
      groupDeleteUrl: '/meter-manager/meter_book_groups/delete/',
      deleteUrl: '/meter-manager/meterBooks/delete',
      query: {
        groupName: '',
        groupId: null, // 添加分组ID字段
        bookName: null, // 添加表册name字段
      },
      bookList: [], // 表册列表
      bookNamesUrl: '/meter-manager/meterBooks/list', // 表册名称接口
      addOrUpdateForm: this.$form.createForm(this, { groupName: 'addOrUpdate' }),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      columns,
      GroupList: [],
      buttonId: 0,
    }
  },
  created() {
    this.getGroupList()
    this.getBookList()
  },
  methods: {
    // 获取分组列表
    getGroupList() {
      this.axios
        .get(this.groupListUrl)
        .then(({ data }) => {
          if (data && Array.isArray(data)) {
            this.GroupList = data
            // 如果有分组数据，默认选中第一个
            // if (this.GroupList.length > 0 && !this.buttonId) {
            //   this.clickButtons(this.GroupList[0].id)
            // }
          }
        })
        .catch(() => {
          this.$message.error('获取分组列表失败')
        })
    },

    // 获取表册列表
    getBookList() {
      // 构建请求参数，如果有选中的分组ID则传入
      const params = this.buttonId ? { groupId: this.buttonId } : {}

      this.axios
        .get(this.bookNamesUrl, { params })
        .then(({ data }) => {
          //根据bookName去重 bookName重复会导致select组件传入的value找不到唯一key
          this.bookList = data.filter(
            (item, index, self) => index === self.findIndex((t) => t.bookName === item.bookName)
          )
        })

        .catch(() => {
          this.$message.error('获取表册列表失败')
        })
    },
    // 获取在册用户列表
    getMeterUsers(bookId, searchParams = {}) {
      this.userTableLoading = true
      // 构建请求参数 - 不传分页参数，获取所有数据
      const params = {
        meterBookId: bookId,
        ...searchParams,
      }

      // 判断是否是搜索请求
      const isSearching = searchParams.userCode || searchParams.userName || searchParams.meterStatus

      this.axios
        .post('/meter-manager/meterBooks/meterUser', params)
        .then(({ data }) => {
          if (data && Array.isArray(data)) {
            const processedData = data.map((item, index) => ({
              ...item,
              sortOrder: item.sortOrder || index + 1,
            }))
            this.allUserData = processedData
            this.userPagination.total = processedData.length

            // 如果不是搜索状态,保存全部用户总数
            if (!isSearching) {
              this.totalUserCount = processedData.length
            }

            // 计算当前页数据
            this.updateCurrentPageData()
          } else {
            this.userData = []
            this.allUserData = []
            this.userPagination.total = 0
          }
          this.userTableLoading = false
          // 初始化拖拽排序
          this.$nextTick(() => {
            this.initSortable()
          })
        })
        .catch(() => {
          this.userData = []
          this.userPagination.total = 0
          this.userTableLoading = false
        })
    },

    // 更新当前页数据
    updateCurrentPageData() {
      const startIndex = (this.userPagination.current - 1) * this.userPagination.pageSize
      const endIndex = startIndex + this.userPagination.pageSize
      
      // 如果有过滤数据，使用过滤数据；否则使用全部数据
      const sourceData = this.filteredUserData || this.allUserData
      this.userData = sourceData.slice(startIndex, endIndex)

      // 确保当前页数据的排序值正确
      this.userData.forEach((item, index) => {
        const allDataItem = this.allUserData.find((allItem) => allItem.id === item.id)
        if (allDataItem) {
          this.$set(item, 'sortOrder', allDataItem.sortOrder)
        }
      })
    },

    // 搜索用户
    searchUsers() {
      // 重置分页到第一页
      this.userPagination.current = 1
      
      // 如果allUserData有数据，说明已经加载过数据，直接在本地过滤
      if (this.allUserData && this.allUserData.length > 0) {
        // 在本地过滤数据，保留已有的排序
        let filteredData = [...this.allUserData]
        
        // 根据搜索条件过滤
        if (this.userSearchForm.userCode) {
          filteredData = filteredData.filter(item => 
            item.userCode && item.userCode.includes(this.userSearchForm.userCode)
          )
        }
        
        if (this.userSearchForm.userName) {
          filteredData = filteredData.filter(item => 
            item.userName && item.userName.includes(this.userSearchForm.userName)
          )
        }
        
        // 只有当用户明确选择了状态时才过滤（'1'是默认值，代表正常状态）
        if (this.userSearchForm.meterStatus && this.userSearchForm.meterStatus !== '') {
          filteredData = filteredData.filter(item => 
            item.meterStatus == this.userSearchForm.meterStatus
          )
        }
        
        // 更新搜索结果
        this.userPagination.total = filteredData.length
        
        // 临时保存过滤后的数据用于分页显示
        this.filteredUserData = filteredData
        
        // 更新当前页数据
        const startIndex = (this.userPagination.current - 1) * this.userPagination.pageSize
        const endIndex = startIndex + this.userPagination.pageSize
        this.userData = filteredData.slice(startIndex, endIndex)
        
        // 重新初始化拖拽排序
        this.$nextTick(() => {
          this.initSortable()
        })
      } else {
        // 如果没有数据，从服务器获取
        const searchParams = {
          userCode: this.userSearchForm.userCode,
          userName: this.userSearchForm.userName,
          meterStatus: this.userSearchForm.meterStatus !== '0' ? this.userSearchForm.meterStatus : null,
        }
        this.getMeterUsers(this.currentId, searchParams)
      }
    },

    // 重置用户搜索
    resetUserSearch() {
      // 重置搜索表单
      this.userSearchForm = {
        userCode: '',
        userName: '',
        meterStatus: '1',
        bookId: this.currentId || null,
      }
      // 重置分页到第一页
      this.userPagination.current = 1
      
      // 清空过滤数据
      this.filteredUserData = null
      
      // 如果有allUserData，直接使用本地数据（保留排序）
      if (this.allUserData && this.allUserData.length > 0) {
        this.userPagination.total = this.allUserData.length
        this.updateCurrentPageData()
        
        // 重新初始化拖拽排序
        this.$nextTick(() => {
          this.initSortable()
        })
      } else {
        // 如果没有本地数据，重新获取
        this.getMeterUsers(this.currentId)
      }
    },

    addOrUpdateHandle(data) {
      console.log(data)
      this.currentId = data.id
      // 保存原始分组ID，用于检测分组变更
      this.originalGroupId = data.groupId
      this.addOrUpdateForm.resetFields()
      this.addOrUpdateVisible = true

      // 重置搜索表单
      this.userSearchForm = {
        userCode: '',
        userName: '',
        meterStatus: '1',
        bookId: data.id || null,
      }

      // 重置分页
      this.userPagination.current = 1
      this.userPagination.total = 0
      // 清空allUserData和过滤数据
      this.allUserData = []
      this.filteredUserData = null

      this.$nextTick(() => {
        this.addOrUpdateForm.setFieldsValue(data)
        // 如果是编辑模式，获取在册用户列表
        this.getMeterUsers(data.id)
      })
    },
    EditModal() {
      if (!this.buttonId) {
        this.$message.warning('请先选择要编辑的分组')
        return
      }
      this.currentGroupId = this.buttonId
      this.groupEditForm.resetFields()
      const currentGroup = this.GroupList.find((item) => item.id === this.buttonId)
      if (currentGroup) {
        this.visiblee = true
        this.$nextTick(() => {
          this.groupEditForm.setFieldsValue({
            groupName: currentGroup.groupName,
          })
        })
      }
    },

    AddModal() {
      this.groupForm.resetFields()
      this.visibles = true
    },

    addHandle() {
      this.addvisible = true
      this.currentId = null
      // 重置表单
      this.addOrUpdateForm.resetFields()
    },

    // 处理新增分组
    handleAddGroup(e) {
      e.preventDefault()
      this.groupForm.validateFields((err, values) => {
        if (!err) {
          this.axios
            .post(this.groupAddOrUpdateUrl, {
              groupName: values.groupName,
            })
            .then(({ code }) => {
              if (code == 0) {
                this.$message.success('新增分组成功')
                this.visibles = false
                this.getGroupList()
              }
            })
            .catch(() => {
              this.$message.error('新增分组失败')
            })
        }
      })
    },

    // 处理编辑分组
    handleEditGroup(e) {
      e.preventDefault()
      this.groupEditForm.validateFields((err, values) => {
        if (!err) {
          this.$http
            .put(this.groupAddOrUpdateUrl, {
              id: this.currentGroupId,
              groupName: values.groupName,
            })
            .then(({ code }) => {
              if (code == 0) {
                this.$message.success('编辑分组成功')
                this.visiblee = false
                this.getGroupList()
              }
            })
            .catch(() => {
              this.$message.error('编辑分组失败')
            })
        }
      })
    },

    // 删除分组
    deleteRow() {
      if (!this.buttonId) {
        this.$message.warning('请先选择要删除的分组')
        return
      }

      this.$confirm({
        title: '确认删除',
        content: '确定要删除该分组吗？',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          this.$http
            .delete(`${this.groupDeleteUrl}${this.buttonId}`)
            .then(({ code }) => {
              if (code == 0) {
                this.$message.success('删除成功')
                this.query = {
                  groupName: '',
                  groupId: null,
                  bookName: null,
                }
                this.queryList()
                this.getGroupList()
              }
            })
            .catch(() => {
              this.$message.error('删除失败')
            })
        },
      })
    },

    handleOk(e) {
      e.preventDefault()
      this.addOrUpdateForm.validateFields((err, values) => {
        console.log(values)

        if (!err) {
          var params
          if (this.currentId) {
            params = {
              meterId: this.currentId,
              ...values,
            }
          } else {
            params = {
              groupId: values.groupId,
              ...values,
            }
          }
          this.$http[!this.currentId ? 'post' : 'put'](this.addOrUpdateUrl, params)
            .then((res) => {
              if (res.code === 0) {
                this.addOrUpdateVisible = false
                this.addvisible = false
                this.queryList()
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    handleCancel() {
      this.visibles = false
      this.visiblee = false
      this.addvisible = false
      this.addOrUpdateVisible = false
      // 清空用户列表数据
      this.userData = []
      this.allUserData = []
      this.filteredUserData = null
      // 重置原始分组ID
      this.originalGroupId = null
      // 重置分页
      this.userPagination.current = 1
      this.userPagination.total = 0
      // 重置用户搜索表单
      this.userSearchForm = {
        userCode: '',
        userName: '',
        meterStatus: '1',
        bookId: null,
      }
    },
    historyData() {
      this.$refs.historyModal.show()
    },
    changeFile(info) {},
    clickButtons(id) {
      this.buttonId = id
      // 更新查询条件中的分组ID
      this.query.groupId = id
      // 重新加载表册列表
      this.getBookList()
      // 清空当前选中的表册
      this.query.bookName = null
      // 重新查询列表
      this.queryList()
    },

    handleChange(value, option) {
      console.log('选中值:', value)
      this.query.bookName = value
      this.queryList()
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().includes(input.toLowerCase())
    },
    // 初始化拖拽排序
    initSortable() {
      const tbody = this.$refs.userTable?.$el?.querySelector('.ant-table-tbody')
      if (!tbody) return

      const _this = this
      Sortable.create(tbody, {
        sort: true,
        handle: '.drag-handle', // 只允许通过拖拽图标进行拖拽
        //  handle: '.ant-table-row',
        animation: 150,
        ghostClass: 'sortable-ghost',
        onStart: function (evt) {
          // 开始拖拽时的处理
          console.log('开始拖拽排序')
        },
        onUpdate: function (evt) {
          // 拖拽排序完成后的处理
          const { newIndex, oldIndex } = evt

          // 判断是否在过滤状态
          const isFiltered = _this.filteredUserData !== null
          const sourceData = isFiltered ? _this.filteredUserData : _this.allUserData

          // 计算在sourceData中的实际索引
          const startIndex = (_this.userPagination.current - 1) * _this.userPagination.pageSize
          const actualOldIndex = startIndex + oldIndex
          const actualNewIndex = startIndex + newIndex

          // 获取被移动的用户ID
          const movedUserId = sourceData[actualOldIndex]?.id

          if (!movedUserId) {
            console.error('无法找到被移动的用户')
            return
          }

          // 在allUserData中找到对应的索引
          const allDataOldIndex = _this.allUserData.findIndex(item => item.id === movedUserId)
          if (allDataOldIndex === -1) {
            console.error('在allUserData中找不到用户')
            return
          }

          // 计算在allUserData中的新位置
          let allDataNewIndex
          if (isFiltered) {
            // 如果在过滤状态，需要根据过滤后的目标位置计算在allUserData中的位置
            const targetUserId = sourceData[actualNewIndex]?.id
            if (targetUserId) {
              allDataNewIndex = _this.allUserData.findIndex(item => item.id === targetUserId)
            } else {
              // 如果移动到最后，使用过滤列表最后一项在allUserData中的位置
              const lastFilteredUserId = sourceData[sourceData.length - 1]?.id
              allDataNewIndex = _this.allUserData.findIndex(item => item.id === lastFilteredUserId)
            }
          } else {
            // 非过滤状态，直接使用计算出的索引
            allDataNewIndex = actualNewIndex
          }

          // 更新allUserData
          const newAllUserData = [..._this.allUserData]
          const movedItem = newAllUserData.splice(allDataOldIndex, 1)[0]
          newAllUserData.splice(allDataNewIndex, 0, movedItem)
          _this.allUserData = newAllUserData

          // 更新所有用户的排序值
          _this.updateSortOrders()

          // 如果在过滤状态，同步更新filteredUserData
          if (isFiltered) {
            const newFilteredData = [...sourceData]
            const filteredMovedItem = newFilteredData.splice(actualOldIndex, 1)[0]
            newFilteredData.splice(actualNewIndex, 0, filteredMovedItem)
            
            // 更新过滤数据中的排序值
            _this.filteredUserData = newFilteredData.map(item => {
              const allDataItem = _this.allUserData.find(allItem => allItem.id === item.id)
              return allDataItem ? { ...item, sortOrder: allDataItem.sortOrder } : item
            })
          }

          // 更新当前页数据
          _this.updateCurrentPageData()

          console.log('拖拽排序完成', { newIndex, oldIndex, actualNewIndex, actualOldIndex, allDataOldIndex, allDataNewIndex })
        },
      })
    },

    // 更新排序值
    updateSortOrders() {
      // 更新allUserData的排序值
      this.allUserData.forEach((item, index) => {
        this.$set(item, 'sortOrder', index + 1)
      })

      // 如果有过滤数据，同步更新过滤数据的排序值
      if (this.filteredUserData) {
        this.filteredUserData = this.filteredUserData.map(item => {
          const allDataItem = this.allUserData.find(allItem => allItem.id === item.id)
          return allDataItem ? { ...item, sortOrder: allDataItem.sortOrder } : item
        })
      }

      // 更新当前页面userData的排序值 - 修复：应该使用allUserData中对应的排序值
      this.userData.forEach((item) => {
        const allDataItem = this.allUserData.find((allItem) => allItem.id === item.id)
        if (allDataItem) {
          this.$set(item, 'sortOrder', allDataItem.sortOrder)
        }
      })
    },

    // 手动输入排序值
    handleSortOrderInput(e, record) {
      // 只更新输入，不做校验，允许先删除再填
      record.sortOrder = e.target.value
    },

    // 键盘事件处理
    handleSortOrderKeydown(e, record) {
      // 只允许输入数字和退格键
      const allowedKeys = ['Backspace', 'Delete', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Home', 'End']
      const isNumber = /^[0-9]$/.test(e.key)

      if (!isNumber && !allowedKeys.includes(e.key)) {
        e.preventDefault()
        return false
      }

      // 如果输入的是0且是第一个字符，阻止输入
      if (e.key === '0' && e.target.value === '') {
        e.preventDefault()
        return false
      }
    },

    handleSortOrderBlur(e, record) {
      const value = e.target.value
      // 允许先清空再输入
      if (!value) {
        // 为空时不做任何处理，等待用户输入
        return
      }
      if (!/^[1-9][0-9]*$/.test(value)) {
        this.$message.warning('请输入有效的正整数')
        // 恢复原有排序值
        const currentIndex = this.allUserData.findIndex((item) => item.id === record.id)
        if (currentIndex !== -1) {
          record.sortOrder = currentIndex + 1
        }
        return
      }
      const newOrder = parseInt(value)

      // 检查输入的数字是否超出范围 - 始终使用allUserData的长度
      const maxOrder = this.allUserData.length
      if (newOrder > maxOrder) {
        this.$message.warning(`序号不能超过总数量 ${maxOrder}`)
        // 恢复原有排序值
        const currentIndex = this.allUserData.findIndex((item) => item.id === record.id)
        if (currentIndex !== -1) {
          record.sortOrder = currentIndex + 1
        }
        return
      }

      // 统一处理排序逻辑
      const currentIndex = this.allUserData.findIndex((item) => item.id === record.id)
      if (currentIndex === -1) return

      // 检查是否需要重新排序（如果输入的位置与当前位置相同，则不需要重新排序）
      if (newOrder === currentIndex + 1) {
        return
      }

      // 创建新数组以避免直接修改原数组
      const newAllUserData = [...this.allUserData]
      // 移除当前项
      const movedItem = newAllUserData.splice(currentIndex, 1)[0]

      // 计算新的插入位置：用户输入的位置减1就是数组索引
      // 例如：用户输入1，应该插入到索引0的位置
      const targetIndex = newOrder - 1

      // 确保索引在有效范围内（移除元素后数组长度减1）
      const newIndex = Math.min(Math.max(0, targetIndex), newAllUserData.length)

      // 插入到新位置
      newAllUserData.splice(newIndex, 0, movedItem)
      // 更新数据
      this.allUserData = newAllUserData
      // 更新所有排序值
      this.updateSortOrders()

      // 判断是否在过滤状态
      const isFiltered = this.filteredUserData !== null
      
      if (isFiltered) {
        // 如果在过滤状态，需要同步更新过滤数据中的排序
        this.filteredUserData = this.filteredUserData.map(item => {
          const allDataItem = this.allUserData.find(allItem => allItem.id === item.id)
          return allDataItem ? { ...item, sortOrder: allDataItem.sortOrder } : item
        })
      }

      // 更新当前页数据
      this.updateCurrentPageData()

      // 只在真正发生排序变化时才提示用户
      this.$message.success(`已将用户移动到第 ${newOrder} 位`)
    },

    // 保存修改并且排序到服务器
    saveSortOrder() {
      // 检测分组是否发生变更
      const currentGroupId = this.addOrUpdateForm.getFieldValue('groupId')
      const hasGroupChanged = this.originalGroupId && this.originalGroupId !== currentGroupId

      // 使用allUserData来保存所有用户的排序
      const users = this.allUserData.map((item, index) => ({
        id: item.id,
        groupId: currentGroupId,
        meterId: this.currentId,
        sortOrder: index + 1,
      }))
      let params = {
        bookName: this.addOrUpdateForm.getFieldValue('bookName'),
        groupId: currentGroupId,
        meterId: this.currentId,
        users,
      }
      this.axios
        .put('/meter-manager/meterBooks', params)
        .then((data) => {
          if (data.code === 0) {
            // 如果分组发生变更，显示特殊提示
            if (hasGroupChanged) {
              this.$message.warning('当前表册已变更所属分组，为了抄表计划的正常执行，请您及时更新抄表计划!')
            } else {
              this.$message.success('保存成功')
            }
            this.queryList()
            // 关闭弹窗
            this.addOrUpdateVisible = false
            // 清空数据
            this.userData = []
            this.allUserData = []
            this.filteredUserData = null
            // 重置原始分组ID
            this.originalGroupId = null
            // 重置分页
            this.userPagination.current = 1
            this.userPagination.total = 0
            // 重置用户搜索表单
            this.userSearchForm = {
              userCode: '',
              userName: '',
              meterStatus: '1',
              bookId: null,
            }
          } else {
            this.$message.error(data.message || '保存失败')
          }
        })
        .catch(() => {})
    },
    // 处理用户表格分页变化
    handleUserTableChange(pagination) {
      this.userPagination.current = pagination.current
      this.userPagination.pageSize = pagination.pageSize
      // 只更新当前页数据，不重新请求接口
      this.updateCurrentPageData()
      // 重新初始化拖拽排序
      this.$nextTick(() => {
        this.initSortable()
      })
    },
  },
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

.tenant-form {
  /deep/ .permission-group {
    margin-top: 0;
    margin-bottom: 0;
  }
}

/deep/.ant-table-thead > tr > th > {
  text-align: center;
}

/deep/.ant-table-tbody > tr > td {
  text-align: center;
  padding: 6px 12px;
}

/deep/ .ant-modal-body {
  padding: 20px;
}

/deep/ .reset-btn.ant-btn {
  margin-left: 12px;
  border: 0.5px solid #bfbfbf;
}

.left-siber {
  flex-direction: column;
  flex: 1;
  width: 300px;
  margin-right: 20px;
}

.right-area {
  display: flex;
  flex-direction: column;
  flex: 4;
}

.dropdown-style /deep/ .ant-collapse {
  background: transparent;
  border: none;
}

.dropdown-style /deep/ .ant-collapse-item {
  border-bottom: none;
}

.ant-btn {
  border: none;
  text-align: left;
}

.top-area {
  flex-direction: column;
}

.form-section {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.select-container {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
}

.button-container {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.EditArea {
  display: flex;
  flex-direction: column;
  background-color: #f2f2f2;
  height: 100px;
  width: 950px;
  padding-top: 10px;
}

.username {
  display: flex;
  margin-top: 20px;
}

.meter-status {
  margin: 20px 10px 0 20px;
  display: flex;
}

.label {
  height: 20px;
  width: 5px;
  background-color: #3badea;
}

/deep/ .EditArea .ant-form-item-label {
  text-align: left;
  padding-left: 20px;
}

// 调整EditArea盒子下两个表单的位置
/deep/ .ant-col-sm-5 {
  box-sizing: border-box;
  width: auto;
}

.ant-form-item {
  box-sizing: border-box;
  margin-bottom: 3px;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  vertical-align: top;
}

// 拖拽排序相关样式
.sort-order-cell {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .drag-handle {
    cursor: move;
    color: #1890ff;
    margin-left: 8px;
    font-size: 14px;

    &:hover {
      color: #40a9ff;
    }
  }
}

// 拖拽时的样式
/deep/ .sortable-ghost {
  opacity: 0.5;
  background-color: #f0f0f0 !important;
}

/deep/ .sortable-table .ant-table-tbody > tr {
  cursor: default;
  &:hover {
    background-color: #f5f5f5;
  }
}

/deep/ .ant-table-tbody > tr.sortable-ghost {
  background-color: #e6f7ff !important;
  border: 2px dashed #1890ff;
}
</style>
